// dynatraceLogger.ts
// Utility to send logs to Dynatrace Log Ingestion API

import { useAppSelector } from "@/store/hooks";
import { store } from "@/store/store";



export async function logErrorToDynatrace(payload: Record<string, any>) {
  if (!import.meta.env.VITE_DYNATRACE_URL || !import.meta.env.VITE_DYNATRACE_API_KEY) {
    // Optionally warn if not configured
    return;
  }

  try {
    await fetch(import.meta.env.VITE_DYNATRACE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Api-Token ${import.meta.env.VITE_DYNATRACE_API_KEY}`,
      },
      body: JSON.stringify([
        {
          log: JSON.stringify(payload),
          app_name:"myasset2.0",
          source:'frontend',
          level: 'ERROR',
          user: localStorage.getItem('userID') || 'unknown',
          ...payload,
        },
      ]),
    });
  } catch (e) {
    // Optionally handle/report failure to log
    console.error('Failed to send log to Dynatrace', e);
  }
}
 